import { Hero } from "../components/sections/Hero";
import { TrustedBy } from "../components/sections/TrustedBy";
import { ServicesSection } from "../components/sections/ServicesSection";
import { ProcessSection } from "../components/sections/ProcessSection";
import { PortfolioSection } from "../components/sections/PortfolioSection";
import { Testimonials } from "../components/sections/Testimonials";
import { FAQSection } from "../components/sections/FAQSection";
import { ContactSection } from "../components/sections/ContactSection";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TrustedBy />
      <ServicesSection />
      <ProcessSection />
      <PortfolioSection />
      <Testimonials />
      <FAQSection />
      <ContactSection />
    </div>
  );
}
